import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { IApplicationContent } from '../../types';
import { RootState } from '../../store/root.state';
import { NearbySchoolsListItemComponent } from './nearby-schools-list-item/nearby-schools-list-item.component';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-nearby-schools-list',
    templateUrl: './nearby-schools-list.component.html',
    styleUrls: ['./nearby-schools-list.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgFor, NgClass, NearbySchoolsListItemComponent]
})
export class NearbySchoolsListComponent implements OnInit {
	@Input() nearbySchools: AbstractControl[];
	@Input() academicYearApplying: number;
	@Input() formGroup: UntypedFormGroup;
	@Input() selectedSchoolID: number;
	@Output() schoolSelected: EventEmitter<number>;

	public schoolsToShowCount: number;
	public appContent: IApplicationContent;

	constructor(private store: Store) {
		this.schoolSelected = new EventEmitter<number>();
	}

	ngOnInit(): void {
		this.appContent = this.store.selectSnapshot(RootState.content);
		this.schoolsToShowCount = 5;
	}

	showMore() {
		this.schoolsToShowCount += 4;
	}

	showLess() {
		this.schoolsToShowCount -= 4;
	}
}
